// extracted by mini-css-extract-plugin
var _1 = "CollapsibleButton-module__button--hs7s3";
var _2 = "CollapsibleButton-module__buttonText--HE7hX";
export { _1 as "button", _2 as "buttonText" }
